@for (learningPath of learningPaths$ | async; track learningPath) {
  <app-learningpath [learningPath]="learningPath"></app-learningpath>
}
